import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kreonetadm.users');
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-portal-kreonetadm-users',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kreonetadm.users/view.scss */
.container {
  height: max-content;
  width: 1800px;
}

.table-vcenter {
  width: 100%;
  margin: 0 auto;
}

.card {
  width: 98%;
  margin: 0 auto;
  max-height: 90%;
  border-left: none;
  border-right: none;
}

.btn-user-plus {
  width: 110px;
  height: 57px;
  background: #DDE8FF 0% 0% no-repeat padding-box;
  border: 1px solid #5263FF;
  color: #5263FF;
  border-radius: 10px !important;
}

.btn-search {
  background: #5263FF 0% 0% no-repeat padding-box;
  border-radius: 0px 999px 999px 0px;
  width: 48px;
  color: white;
  height: 40px;
}

.btn-save {
  background: #5263FF 0% 0% no-repeat padding-box;
  border-radius: 10px !important;
  width: 110px;
  color: white;
  height: 57px;
}

.admin-icon {
  background: none;
  border: none;
  color: #5263FF;
  opacity: 1;
}

.add-plus {
  width: 441px;
  height: 308px;
  margin: auto;
  border: 1px solid #D1D1D1;
  border-radius: 10px !important;
}

img {
  max-width: none;
  height: none;
}

.select-box {
  width: 100%;
  max-width: 1592px;
  margin: auto;
  justify-content: space-around;
  align-items: center;
}

.btn-plus {
  background: #DDE8FF 0% 0% no-repeat padding-box;
  border: 1px dashed #5263FF;
  border-radius: 7px !important;
  width: 441px;
  height: 40px;
  margin: auto;
}

.btn-one {
  background-color: white;
  border: 2px solid #5263FF;
}

.btn-green {
  background-color: white;
  border: 2px solid #6AD96E;
}

.wiz-form {
  width: 96%;
  margin: auto;
}

.btn {
  font: normal normal normal 16px/18px NanumSquare;
}
.btn.active {
  background: var(--wc-blue);
  color: white;
}

.buttons {
  width: 90%;
  margin: 0 auto;
  background: none;
  border: none;
  justify-content: space-between;
  max-width: 1592px;
  margin-bottom: 1rem;
}

.btn-red {
  border: 2px solid #E20C0C;
  background: #FFFFFF;
}

.search-box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 23%;
  height: fit-content;
}
@media (max-width: 1200px) {
  .search-box {
    width: 97%;
  }
}

.btn-status {
  width: 48px;
  height: 48px;
  border-radius: 24px;
}

.btn-none {
  border: none;
  background: none;
}

button.disabled {
  background-color: inherit;
  opacity: 1;
  pointer-events: none;
}

button.disabled:disabled {
  pointer-events: none;
}

.dropdown1 .dropdown-toggle {
  padding-left: 0.5rem;
  border-radius: 999px 0px 0px 999px;
  justify-content: space-between;
  height: 40px;
  width: 90px;
  color: #707070;
  border: none;
  font: normal normal bold 14px/16px SUIT;
}
.dropdown1 .dropdown-menu {
  max-width: 91px;
  min-width: 5%;
  transform: translate3d(455.5px, 202px, 0px);
}
.dropdown1 .dropdown-item {
  min-width: 0;
}

.card-div {
  width: 1592px;
  height: 844px;
  background-color: white;
  margin: 0 auto;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1019607843);
  border-radius: 20px;
  padding: 0.5rem;
}

.card-table .table {
  min-width: 1520px;
  border-radius: 0px;
}
.card-table .table th {
  font-size: 14px;
  background: #F6F7FB;
  padding: 8px 12px;
}
.card-table .table thead {
  position: sticky;
  top: 0;
}
.card-table .table tbody {
  background: #fff;
}
.card-table .table tbody td {
  white-space: nowrap;
}
.card-table .table tbody .user-status-icon {
  display: inline-block;
  width: 20px;
  text-align: center;
  line-height: 1;
  padding: 4px 0;
  font-size: 12px;
  border-radius: 10px;
  background: var(--wc-blue);
  color: #fff;
}
.card-table .table tbody .btn i {
  width: 16px;
}

.form-control {
  font-size: 0.875rem !important;
  height: 40px;
  border-radius: 0px !important;
  border: none;
}

.btn-admin {
  border: 2px solid #FFCE52;
}

.btn-outline-secondary {
  border: 2px solid #6D6D6D;
}

.btn-manager {
  border: 2px solid #FF7676;
}

.wiz-form .wiz-form-rows {
  min-height: 78px;
}

.sidebar {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  max-width: 481px;
  background: #fff;
  border-left: 1px solid var(--wc-border);
  z-index: 10;
  overflow: auto;
}
.sidebar .sidebar-close {
  border: none;
  box-shadow: none;
}
.sidebar .card {
  border: none;
}
.sidebar .card > * {
  border-radius: 0;
}
.sidebar .form-control {
  max-width: 580px;
  margin-bottom: 10px;
  margin: auto;
}
.sidebar .card-title {
  font: normal normal bold 20px/25px SUIT;
  color: black;
}
.sidebar .guide-box {
  background: #FFF6F5 0% 0% no-repeat padding-box;
  width: 580px;
  height: auto;
  padding: 1rem;
  margin: auto;
  border-radius: 10px;
  margin-top: 30px;
  margin-bottom: 30px;
}
.sidebar .guide-box span {
  font: normal normal normal 16px/24px SUIT;
  color: #EF2B2A;
}
.sidebar .btn-blue {
  background: #2547F4 0% 0% no-repeat padding-box;
  border-radius: 10px;
  color: white !important;
}
.sidebar h4 {
  font: normal normal bold 16px/20px SUIT;
  margin-bottom: 3px;
  color: #EF2B2A;
}
.sidebar h3 {
  margin: auto;
  max-width: 580px;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  font: normal normal bold 18px/23px SUIT;
  color: #000000;
}
.sidebar hr {
  margin: auto;
  margin-top: 2rem;
  max-width: 580px;
}
.sidebar .btn-apply {
  margin-top: 30px;
  margin-left: 10px;
  border-radius: 7px;
  height: 48px;
  width: 285px;
  font: normal normal normal 16px/21px SUIT;
  background-color: #5263ff;
  color: white;
}
.sidebar .btn-list {
  margin-top: 30px;
  border-radius: 7px;
  height: 48px;
  width: 285px;
  font: normal normal normal 16px/21px SUIT;
  background-color: #D1D1D1;
}`],
})
export class PortalKreonetadmUsersComponent implements OnInit {

    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    public async ngOnInit() {
        await this.service.init();
        this.title.setTitle('관리자 - 사용자관리 - MY KREONET');
        await this.service.auth.allow('admin', '/');
        await this.load();
    }
    public sidebar = false;
    public userIns: any;
    public allData: any;
    public mcate = "name";
    public modal = false;
    public institutes = [];
    public data = {
        name: '',
        email: '',
        role: '',
        institute: '',
        ins_role: ''
    }
    public user_roles = [
        '-',
        '관리책임자',
        '전산담당자',
        '연회비담당자',
        '연구책임자',
        '실무연구자'
    ];
    @ViewChild('handsontable')
    public table: ElementRef;
    public handsontable: any = null;
    public year: number = 0;
    public listloaded: boolean = false;
    public list: any = [];
    public status: string = 'active';
    public post = {};
    public search_word = '';
    public wizForms = [
        { role: '', institute: '', ins_role: '' }
    ];

    public searchForm: any = {
        page: 1,
        text: ''
    };

    public pagenation: any = {
        page: 1,
        end: 1,
        start: 1,
    };

    public async alert(message: string, status: any = "error", confirm: boolean = false) {
        const result = await this.service.alert.show({
            title: '',
            message: message,
            cancel: confirm ? "취소" : undefined,
            actionBtn: status,
            action: "확인",
            status: status
        });
        return confirm ? result : true;
    }

    private async search() {
        if (this.search_word.length === 0) {
            await this.alert("검색어를 입력해주세요.");

        }
        this.pagenation.page = 1;
        await this.load();
    }


    public async load() {
        this.listloaded = false;
        let { code, data } = await wiz.call("list", { page: this.pagenation.page, text: this.searchForm.text, status: this.status, mcate: this.mcate });
        if (code != 200) return;
        let { rows, lastpage, institutes_list, user_ins } = data;
        this.list = rows;
        this.institutes = institutes_list;
        this.userIns = user_ins;
        this.pagenation.start = Math.floor((this.pagenation.page - 1) / 10) * 10 + 1;
        this.pagenation.end = data.lastpage;
        this.listloaded = true;
        await this.service.render();
    }


    public async addForm() {
        this.wizForms.push({ role: '', institute: '', ins_role: '', email: this.data.email });

    }

    public async onUpload() {
        const { code, data } = await wiz.call("plus_ins", { data: JSON.stringify(this.wizForms) })
        if (code == 200) {
            await this.alert('저장되었습니다.', 'success')
        } else {
            await this.alert('저장에 실패했습니다.', 'error')
        }
    }

    public async addUser() {
        this.modal = true;
        console.log(this.modal)
        await this.service.render();
    }


    public async addIns(index: string) {
        this.data = this.list[index];
        this.wizForms[0].email = this.data.email;
        this.userIns.filter(user => user.email === this.data.email).forEach(user => {
            this.wizForms.push({
                email: user.email,
                id: user.id,
                ins_role: user.ins_role,
                role: user.role,
                institute: user.institute
            });
        });
        console.log(this.wizForms);
        this.sidebar = 'new';
        this.data.dataset_id = 'new';
        await this.service.render();
    }
    // public async pageMove(page: number) {
    //     await this.load(page);
    // }

    public async update() {
        let isDuplicate = this.list.map(user => user.email)
            .filter((email, index, arr) => arr.indexOf(email) !== index).length > 0;

        if (isDuplicate) {
            await this.alert('중복된 이메일이 존재합니다.', 'warning');
            return;
        }
        const { code, data } = await wiz.call("update", { data: JSON.stringify(this.list) })
        if (code == 200) {
            await this.alert('저장되었습니다.', 'success')
        } else {
            await this.alert('저장에 실패했습니다.', 'error')
        }
    }

    public async selectValue(value: string): void {
        this.mcate = value; // mcate 값 설정
        this.data = this.allData[value]; // 선택된 항목에 맞는 데이터 리스트를 업데이트
    }

    public async changeStatus(item: any, status: string) {
        let res = false;
        if (status == 'active')
            res = await this.alert('사용자 접속을 승인하겠습니까?', 'success');
        if (status == 'inactive')
            res = await this.alert('사용자를 차단하겠습니까?', 'error');
        if (!res) return;
        item.status = status;
        await wiz.call("changeStatus", item);
        await this.pageLoad(this.searchForm.page);
    }
    public async eachUpdate(id, user) {
        let isDuplicate = this.list.some(existingUser =>
            existingUser.email == user.email && existingUser.id != id
        );

        if (isDuplicate) {
            await this.alert('중복된 이메일이 존재합니다.', 'warning');
            return;
        }
        this.post.id = id;
        this.post = user;
        const { code, data } = await wiz.call("eachUpdate", this.post)
        if (code == 200) {
            await this.alert('저장되었습니다.', 'success')
        } else {
            await this.alert('저장에 실패했습니다.', 'error')
        }
        this.post = [];

    }

    public async sidebarClose() {
        this.sidebar = null;
        await this.service.render();
    }


    public async changeRole(user: any, roleE: any, roleK: any) {
        let text = roleK + "로 지정하시겠습니까?";
        let res = await this.alert(text, 'success', '취소');
        if (res) {
            await wiz.call("changeRole", { user: user.id, role: roleE });
            await this.pageLoad(this.searchForm.page);
        }
    }


    public async deleteUser(user: string) {
        const confirmed = await this.alert('사용자를 삭제하시겠습니까?', 'success', true);
        if (!confirmed) return;

        const { code } = await wiz.call("delete", { user })
        if (code == 200) {
            await this.alert('삭제되었습니다.', 'success')
        } else {
            await this.alert('삭제에 실패했습니다.', 'error')
        }
        this.pageLoad(1);
    }
    public async selectValue(category: string): void {
        this.mcate = category;
        this.searchForm.text = '';
        this.searchForm.page = 1;
        await this.load()
    }
    private pageLoad(p: number, status: any = null) {
        this.pagenation.page = p;
        if (status) this.status = status;
        this.load();
    }
}

export default PortalKreonetadmUsersComponent;